import {
  HorizAlignment, ISearch, ISearchProfile, ISearchProvider,
  SearchProviderFieldType,
  ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_CannibalizationSet_Search_Fields: {[id:string]: ISearchProviderField } = {
  WB_CANN_ID:          {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
  CANN_NAME:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
  CANNIB_TYPE_NAME:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Type', columnResourceName: 'colCannType', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
  CUSTOMER_NAME:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer', columnResourceName: 'colCustomer', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
  CUST_ROLE:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer Role', columnResourceName: 'colCustomerRole', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
  PRODUCT_GROUP_NAME:  {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Affinity Set', columnResourceName: 'colCannAffiSet', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
  AUTHUSR_NAME:        {type: SearchProviderFieldType.string, renderOptions: { columnName: 'User', columnResourceName: 'colCannAuthUsr', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
  TREE_PATH:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Tree Path', columnResourceName: 'colTreePath', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}}
}

const CannibalizationSetSearchProviderBasic: ISearchProvider = {

  keyFields: {id:    'WB_CANN_ID',
              id_ui: 'WB_CANN_ID',
              name:  'CANN_NAME'},

  searchProviderFields: vUI_CannibalizationSet_Search_Fields,

  search(searchOptions: ISearchRequestSubset): Promise<any[]> {
    return new Promise<any[]>((resolve, error) => {

      let findRequest = SearchUtils.makeSearchRequest(searchOptions,
        'vUI_CannibalizationSet_Search',
        this.searchProviderFields,
        [])

      PASearch.findByRequest(findRequest)
        .then((res: any[]) => {
          resolve(res)
        })
        .catch((err)=> {
          error(err)
        })
    })
  }

}


const CannibalizationSetSearchProfileByName: ISearchProfile = {
  profileId: "default",
  profileName: "Search by Id, Name",
  renderOptions: { ui5ResourceId: "CannibalizationSetSearchProfileByName" },

  profileFilter: [
    {profileFilterName: 'Name',   searchProviderFieldId: 'CANN_NAME', renderOptions: { }}
  ],  // ISearchFields
  profileDisplayFields: [
    'CANN_NAME','CANNIB_TYPE_NAME','PRODUCT_GROUP_NAME','AUTHUSR_NAME'
  ],

  profileSearchProvider: CannibalizationSetSearchProviderBasic,

  // Do sorting last.. not necessary for phase 1
  profileSortIdDefault: "",    //string;
  profileSorts: [] //ISearchSort[];
}


const CannibalizationSetSearch: ISearch = {
  searchName: "Find CannibalizationSet",
  renderOptions: { ui5ResourceId: "CannibalizationSetSearch"},
  searchProfileIdDefault: "default",
  searchProfiles: [CannibalizationSetSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("CannibalizationSetBO", "Cannibalization", CannibalizationSetSearch, "Cannibalization Set Search")

export {CannibalizationSetSearch}
